module.exports = "<div fxLayout=\"column\" class=\"about\" fxLayoutAlign=\"center center\"\n     fxFlex>\n\n  <div class=\"primary\" fxLayout fxLayoutGap=\"15px\" fxLayoutAlign=\"center center\">\n      <contributor\n          [info]=\"person\"\n          *ngFor=\"let person of authors\">\n      </contributor>\n  </div>\n\n  <div class=\"contributors\" fxLayout=\"row\" fxLayoutGap=\"15px\"  fxLayoutAlign=\"start center\">\n      <contributor\n          [info]=\"person\"\n          *ngFor=\"let person of contributors\">\n      </contributor>\n  </div>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about-page/about-page.component.html
// module id = 217
// module chunks = 1